<template>
  <div>
    <div v-if="horizontal" class="align-btns">
      <span>{{ $t('message.H_TEXT_ALIGN') + $t('message.TWO_DOTS') }}</span>
      <img
        v-for="(option, index) in hAlignOptions"
        :src="require(`@/assets/img/${option.src}`)"
        alt=""
        :class="{ selected: value == index }"
        v-quick-title="option.hint"
        @click="$emit('input', index)"
      />
    </div>
    <div v-else class="align-btns">
      <span>{{ $t('message.V_TEXT_ALIGN') + $t('message.TWO_DOTS') }}</span>
      <img
        v-for="(option, index) in vAlignOptions"
        :src="require(`@/assets/img/${option.src}`)"
        alt=""
        :class="{ selected: value == index }"
        v-quick-title="option.hint"
        @click="$emit('input', index)"
      />
    </div>
  </div>
</template>

<script>
/**
 * Three-option text alignment selector
 */


export default {
  name: 'TextAlignSelector',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    horizontal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hAlignOptions: [
        { src: 'align-left-medium-gray.png', hint: this.$t('message.ALIGN_TEXT_LEFT') },
        { src: 'align-center-medium-gray.png', hint: this.$t('message.ALIGN_TEXT_CENTER') },
        { src: 'align-right-medium-gray.png', hint: this.$t('message.ALIGN_TEXT_RIGHT') },
      ],
      vAlignOptions: [
        { src: 'align-top-medium-gray.png', hint: this.$t('message.ALIGN_TEXT_TOP') },
        { src: 'align-middle-medium-gray.png', hint: this.$t('message.ALIGN_TEXT_MID') },
        { src: 'align-bottom-medium-gray.png', hint: this.$t('message.ALIGN_TEXT_BOT') },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.align-btns {
  bottom: 30px;

  img {
    vertical-align: middle;
    width: 20px;
    padding: 3px;
    cursor: pointer;
    border-radius: 5px;

    &:hover, &.selected {
      background-color: $color-hoverbtn-light-blue;
    }
  }
}
</style>
